import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  DataType,
  GroupNames,
  MaxLength,
  Modules,
  NotificationHeader,
  NotificationTextMessage,
} from '@app/core/Enum';
import {
  FixedAssetDepreciationModel,
  GlobalComponent,
  MainListParameters,
  SideListModel,
} from '@app/core/Models';
import { CommonService, NotificationService } from '@app/core/Services';
import {
  FixedAssetsRegisterState,
  GetDepreciationTransaction,
  GetFixedAssetRegisterDataList,
  GetFundNameList,
  SaveDepreciation,
} from '@app/core/Store';
import { ViewReceiptComponent } from '@app/modules/common';
import { Select, Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { tap, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-depreciation-expanded-collapse',
  templateUrl: './depreciation-expanded-collapse.component.html',
  styleUrls: ['./depreciation-expanded-collapse.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('isExpanded', style({ height: '*', visibility: 'visible' })),
      transition(
        'isExpanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class DepreciationExpandedCollapseComponent implements OnInit {
  fixedAssetRegisterList: any;

  moduleId = Modules.FixedAssetsRegister;
  maxLength = MaxLength;
  dataType = DataType;
  dataSource = new MatTableDataSource();
  startDate = new Date();
  endDate = new Date();
  listParameters: MainListParameters = new MainListParameters();

  isAllSelected = false;
  noDataFound = false;
  isSelected = false;
  isAmortizationMode = false;

  titleText = 'Depreciation';
  lastLabelText = 'Last Depreciate';
  accumulatedLabelText = 'Acc. Depreciation';
  amountLabelText = 'Depreciation';

  displayedColumns: string[] = [
    'button',
    'assestName',
    'fundName',
    'acquiredDate',
    'lastDepreciate',
    'acquiredPrice',
    'accDepreciation',
    'rateYear',
    'method',
    'depreciation',
    'bookValue',
  ];
  fundNameList: SideListModel[];
  fixedAssetDepriciationData: Array<FixedAssetDepreciationModel>;
  periodicDateList: any;
  depreciationForm: FormGroup;

  fixedAssetItemId = '';
  @ViewChild(MatSort) sort: MatSort;
  expandedCollapseDetailList: any;

  @Select(FixedAssetsRegisterState.expandedCollapseColumnNames)
  columnsNames$: Observable<Array<string>>;

  @Select(FixedAssetsRegisterState.expandedCollapseColumns)
  columns$: Observable<
    Array<{
      name: string;
      value: string;
      dataType?: DataType;
      allowSortBy?: boolean;
      alignment: string;
    }>
  >;

  constructor(
    private store: Store,
    private globalComponent: GlobalComponent,
    public dialogRef: MatDialogRef<DepreciationExpandedCollapseComponent>,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    public commonService: CommonService,
    private notify: NotificationService,
    public dialog: MatDialog,
    private renderer: Renderer2,
     @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
     this.moduleId = this.data.moduleId;
    this.setLabels();
    this.setForm();
    this.setPeriodDate();
  }

  setLabels(): void {
    this.isAmortizationMode =
      this.moduleId === Modules.ActiveIntangibleFixedAssets;

    if (this.isAmortizationMode) {
      this.titleText = 'Amortization';
      this.lastLabelText = 'Last Amortized';
      this.accumulatedLabelText = 'Acc. Amortization';
      this.amountLabelText = 'Amortization';
    }
  }

  setForm(): void {
    this.depreciationForm = new FormGroup({
      accountingPeriod: new FormControl(''),
      fundId: new FormControl(null),
      entryDate: new FormControl(new Date()),
    });
  }

  checkSelectAll(event: any): void {
    this.updateSelectionState();
  }

  selectAll(event: any): void {
    this.fixedAssetRegisterList.forEach((x) => (x.isSelected = event.checked));
    this.updateSelectionState();
  }

  private updateSelectionState(): void {
    const selectedCount = this.fixedAssetRegisterList.filter(
      (element) => element.isSelected
    ).length;

    this.isSelected = selectedCount > 0;
    this.isAllSelected =
      this.fixedAssetRegisterList.length > 0 &&
      selectedCount === this.fixedAssetRegisterList.length;
  }

  expandCollapse(row, filter, index: number): void {
    if (row.isExpanded) {
      row.isExpanded = false;
    } else {
      this.fixedAssetRegisterList.forEach((element, i) => {
        if (i !== index) {
          element.isExpanded = false;
        }
      });
      row.isExpanded = true;
      this.listParameters.filter = filter;
      this.fixedAssetItemId = row.fixedAssetExplainId;
      this.fetchTransactionList(this.fixedAssetItemId);
    }
  }

  sorting(sortBy: string, sortOrder: string): void {
    this.listParameters.sortOrder = sortOrder === 'asc' ? true : false;
    this.listParameters.sortBy = sortBy;
    this.fetchTransactionList(this.fixedAssetItemId);
  }

  getTranactionParamter(): any {
    const queryParams = {
      pageNumber: this.listParameters.pageNumber,
      pageSize: this.listParameters.pageSize,
      filter: this.listParameters.filter,
      sortBy: this.listParameters.sortBy,
      sortOrder: this.listParameters.sortOrder,
      search: this.listParameters.search,
      moduleId: this.listParameters.moduleId ?? (Guid.EMPTY as unknown as Guid),
      subModuleId: this.listParameters.subModuleId ?? -1,
      ids: this.listParameters.ids ?? null,
      startDate: this.datepipe
        .transform(
          this.depreciationForm.controls.accountingPeriod.value.fromDate,
          'yyyy-MM-dd'
        )
        ?.toString(),
      endDate: moment(
        this.depreciationForm.controls.entryDate.value.valueOf()
      ).format('yyyy-MM-DD'),
    };
    return queryParams;
  }

  fetchTransactionList(fixedAssetItemId): void {
    this.spinner.show();
    this.store
      .dispatch(
        new GetDepreciationTransaction(
          this.getTranactionParamter(),
          fixedAssetItemId
        )
      )
      .subscribe((res) => {
        this.spinner.hide();
        this.expandedCollapseDetailList =
          res.fixedAssetRegister.expandedCollapseDepreciationDetailList.resultSet.data;
        this.noDataFound =
          this.expandedCollapseDetailList.length === 0 ? true : false;
        this.dataSource.data = this.expandedCollapseDetailList;
      });
  }

  setPeriodDate(): void {
    this.periodicDateList = this.globalComponent.getFinancialPeriod();
    this.depreciationForm.controls.accountingPeriod.setValue(
      this.periodicDateList[0]
    );
    this.getFundNameList();
    this.onAccountPeriodChange();
  }

  getFundNameList(): void {
    this.store
      .dispatch(new GetFundNameList())
      .pipe(
        tap((res) => {
          this.fundNameList = res.account.fundNameList;
          this.setupFundIdChangeListener();
          this.getList();
        })
      )
      .subscribe();
  }

  setupFundIdChangeListener(): void {
    this.depreciationForm.controls.fundId.valueChanges
      .pipe(debounceTime(300))
      .subscribe(() => {
        this.getList();
      });
  }

  getParamter(): any {
    const queryParams = {
      pageNumber: this.listParameters.pageNumber,
      pageSize: this.listParameters.pageSize,
      filter: this.listParameters.filter,
      sortBy: this.listParameters.sortBy,
      sortOrder: this.listParameters.sortOrder,
      search: this.listParameters.search,
      moduleId: this.listParameters.moduleId ?? (Guid.EMPTY as unknown as Guid),
      subModuleId: this.listParameters.subModuleId ?? -1,
      ids: this.listParameters.ids ?? null,
      startDate: this.datepipe
        .transform(
          this.depreciationForm.controls.accountingPeriod.value.toDate,
          'yyyy-MM-dd'
        )
        ?.toString(),
      endDate: moment(
        this.depreciationForm.controls.entryDate.value.valueOf()
      ).format('yyyy-MM-DD'),
    };
    return queryParams;
  }

  getList(): void {
    this.fixedAssetRegisterList=[];
    this.noDataFound =true;
       if ((!this.depreciationForm.controls.entryDate.value) || (!this.depreciationForm.controls.accountingPeriod.value)) {
      this.commonService.addValidation(
        this.depreciationForm,
        this.renderer
      );
    }else{
       let grpModuleId: any;
    if (this.moduleId === Modules.ActiveTangibleFixedAssets) {
      grpModuleId = GroupNames.FixedAssets_Tangibles;
    }
    if (this.moduleId === Modules.ActiveLeasedFixedAssets) {
      grpModuleId = GroupNames.FixedAssets_Heritage;
    }
    if (this.moduleId === Modules.ActiveIntangibleFixedAssets) {
      grpModuleId = GroupNames.FixedAssets_Intangibles;
    }
    if (this.depreciationForm.controls.entryDate.value) {
      this.spinner.show();
      this.store
        .dispatch(new GetFixedAssetRegisterDataList(this.getParamter(), grpModuleId))
        .subscribe((res) => {
          this.spinner.hide();
          this.fixedAssetRegisterList =
            res.fixedAssetRegister.fixedAssetRegisterDataList;
          this.fixedAssetRegisterList.forEach((element) => {
            element.percentage = 1;
            element.isSelected = false;
          });
          this.updateSelectionState();
          this.noDataFound =
            this.fixedAssetRegisterList.length === 0 ? true : false;
        });
    }
  }
  }

  onChange(element): void {
    const checkAmount = +element.totalAmount - +element.totalDepreciation;
    const amount = +element.amount;

    if (!this.isValidAmount(amount, checkAmount)) {
      this.showAmountError(element, checkAmount);
      return;
    }

    element.bookValue = this.calculateBookValue(element, amount, checkAmount);
  }

  private isValidAmount(amount: number, checkAmount: number): boolean {
    return amount !== 0 && amount <= checkAmount;
  }

  private showAmountError(element: any, checkAmount: number): void {
    if (+element.amount > checkAmount) {
      this.commonService.onFailure(NotificationTextMessage.amountErrorMessage);
    }
    element.amount = 0;
    element.bookValue = +checkAmount;
  }

  private calculateBookValue(element: any, amount: number, checkAmount: number): number {
    if (element.percentage === 1) {
      const remaining = +element.totalAmount - +element.totalDepreciation;
      return remaining - (remaining * amount) / 100;
    }

    return checkAmount - amount;
  }

  dataSubmit(): boolean {
    this.spinner.show();
    try {
      this.fixedAssetDepriciationData =
        new Array<FixedAssetDepreciationModel>();
      this.fixedAssetRegisterList.forEach((element) => {
        if (element.isSelected) {
          this.fixedAssetDepriciationData.push({
            id: element.id,
            fundId: element.fundId,
            amount: +element.amount,
            name: element.name,
            acquiredDate: element.acquiredDate,
            entryDate: moment(
              this.depreciationForm.controls.entryDate.value.valueOf()
            ).format('yyyy-MM-DD'),
            totalAmount: +element.totalAmount,
            totalDepreciation: +element.totalDepreciation,
            bookValue: +element.bookValue,
            journalId: element.journalId,
            accountingPeriodId:
              this.depreciationForm.controls.accountingPeriod.value.id,
            fixedAssetExplainId: element.fixedAssetExplainId,
            rate: element.rate,
            method: element.method,
            methodTypeId: element.methodTypeId,
            lastDepreciate: element.lastDepreciate,
            isTangible: element.isTangible,
          });
        }
      });
    } catch (error) {
      this.spinner.hide();
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  onSave(): void {
     if(this.depreciationForm.valid){
    if (this.dataSubmit() && this.fixedAssetDepriciationData.length > 0) {
      this.store
        .dispatch(new SaveDepreciation(this.fixedAssetDepriciationData))
        .subscribe((res) => {
          this.spinner.hide();
          if (res !== null && res !== undefined) {
            this.onCloseClick();
            this.notify.success(
              NotificationHeader.success,
              NotificationTextMessage.successMessage
            );
          } else {
            this.notify.error(
              NotificationHeader.error,
              NotificationTextMessage.errorMessage
            );
          }
        });
    } else if (!this.isSelected) {
      this.commonService.onFailure(
        NotificationTextMessage.noSelectedErrorMessage
      );
    }
     } else {
      this.notify.error(
        NotificationHeader.error,
        NotificationTextMessage.invalidDateSelection
      );
    }
  }

  onCancel(): void {
    this.fixedAssetRegisterList.forEach((x) => (x.isSelected = false));
    this.updateSelectionState();
    this.ngOnInit();
    this.expandedCollapseDetailList = [];
    this.dataSource.data = [];
    this.fixedAssetRegisterList = [];
    this.updateSelectionState();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onAccountPeriodChange(): void {
    let accountingId = this.depreciationForm.get('accountingPeriod')?.value;
    this.periodicDateList.forEach((element) => {
      if (element.id === accountingId.id) {
        this.startDate = element.fromDate;
        let curdate=new Date();
        let endDate=new Date(element.toDate);
        this.endDate = (endDate > curdate)?curdate:endDate;
        this.depreciationForm.controls.entryDate.setValue(
      this.endDate
    );
      }
    });
    this.getList();
  }

  redirect(id: any, moduleId: number): void {
    if (moduleId > 0) {
      if (moduleId === Modules.Journals) {
        const data = {
          moduleId,
          id,
          hideEditButton: true,
        };

        this.dialog
          .open(ViewReceiptComponent, {
            data,
            disableClose: true,
          })
          .afterClosed()
          .subscribe((result) => {});
      } else {
        this.commonService.onEditRouting(true, moduleId, id);
      }
    }
  }
}
